import React from 'react';
import { getBackground } from 'core/config/backgrounds';

/**
 * Dezenter, fixierter Seiten-Hintergrund (Icons / Bild / GIF) hinter dem Inhalt.
 *
 * Liest die Konfiguration aus `config/backgrounds.js` anhand des `name`-Schlüssels.
 * Liegt dort keine Datei (`src`), wird nichts gerendert.
 *
 * @param {{ name?: string }} props Seiten-Schlüssel (z.B. 'overview', 'aktien', 'detail').
 */
export default function PageBackground({ name }) {
  const bg = getBackground(name);
  if (!bg || !bg.src) return null;

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-10"
      style={{
        backgroundImage: `url(${bg.src})`,
        backgroundRepeat: bg.repeat || 'no-repeat',
        backgroundSize: bg.size || 'cover',
        backgroundPosition: bg.position || 'center',
        opacity: bg.opacity ?? 0.05,
      }}
    />
  );
}
